import { Navigate, Outlet } from "react-router-dom";
import { useAuthState } from "../../context/FirebaseContext";
import Loading from "../Loading";
import React, { useMemo, useContext } from "react";
import { FirebaseContext } from "../../context/FirebaseContext";

const AnonRoute = ({ children }) => {
  const { isAuthenticated, loadingUser, user } = useAuthState();
  const { isMaintenanceMode } = useContext(FirebaseContext);

  // Memoizar la lógica de autenticación
  const renderContent = useMemo(() => {
    if (loadingUser) return <Loading />;
    
    // Si está autenticado, redirigir según el modo mantenimiento
    if (isAuthenticated) {
      // Si está en modo mantenimiento y no es super admin, redirigir a mantenimiento
      if (isMaintenanceMode && (!user || !user.roles?.super)) {
        return <Navigate to="/maintenance-mode" replace />;
      }
      // Si está autenticado y no hay mantenimiento (o es super admin), ir al home
      return <Navigate to="/" replace />;
    }
    
    // Si no está autenticado, permitir acceso a la página (login)
    // No bloquear el login por modo mantenimiento
    return children || <Outlet />;
  }, [loadingUser, isAuthenticated, isMaintenanceMode, user]);

  return renderContent;
};

export default React.memo(AnonRoute);
